import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getSSODataCount } from "src/actions/sso";
import Button from "src/components/Shared/Button";
import SelectMenu from "src/components/Shared/SelectMenu";
import Search from "src/components/Users/Search";

const CardSSOForm = ({ sso, getSSODataCount, perPage, setPerpage, offset, groups, ...props }) => {
  const [status, setStatus] = useState("");
  const [keyword, setKeyword] = useState("");

  const navigate = useNavigate();
  useEffect(() => {
    const ac = new AbortController();

    const loadFilteredRole = async () => {
      props.setLoaded(false);

      try {
        const ssoCount = await getSSODataCount(
          {
            default: status,
            keyword,
            limit: +perPage,
            offset: offset * +perPage,
          },
          ac.signal
        );

        props.setCount(ssoCount);

        const availablePages = Math.ceil(ssoCount / +perPage);
        props.setPages(availablePages);
        props.setLoaded(true);
      } catch (err) {
        props.setLoaded(true);
        console.dir(err.message);
      }
    };

    loadFilteredRole();

    return () => ac.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offset, perPage, sso.length]);

  useEffect(() => {
    const ac = new AbortController();

    const loadFilteredRole = async () => {
      props.setLoaded(false);

      try {
        const ssoCount = await getSSODataCount(
          {
            default: status,
            keyword,
            limit: +perPage,
            offset: 0,
          },
          ac.signal
        );

        props.setCount(ssoCount);

        const availablePages = Math.ceil(ssoCount / +perPage);
        props.setPages(availablePages);
        props.setOffset(0);
        props.setLoaded(true);
      } catch (err) {
        props.setLoaded(true);
        console.dir(err.message);
      }
    };

    loadFilteredRole();

    return () => ac.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyword, status]);

  return (
    <div className="flex justify-between items-center">
      <div className="w-full justify-between flex">
        <div className="flex gap-x-2 w-4/5">
          <Search keyword={keyword} setKeyword={setKeyword} />
          <div className="hidden md:flex gap-x-1">
            <SelectMenu
              options={[
                { key: "10 Per Page", value: 10 },
                { key: "20 Per Page", value: 25 },
                { key: "50 Per Page", value: 50 },
                { key: "75 Per Page", value: 75 },
                { key: "100 Per Page", value: 100 },
                { key: "All", value: 1000000000 },
              ]}
              setOption={(option) => {
                setPerpage(option.value);
                props.setOffset(0);
              }}
            />

            <SelectMenu
              options={[
                { key: "All Status", value: "" },
                { key: "Active", value: "true" },
                { key: "Inactive", value: "false" },
              ]}
              setOption={(option) => {
                if (option.value) {
                  setStatus(option.value === "true");
                } else {
                  setStatus(option.value);
                }
              }}
            />
          </div>
        </div>
        <div className="relative flex w-[140px] gap-x-1 items-center justify-end">
          <Button styleType="secondary" onClick={() => navigate("/sso/add")}>
            Add SSO
          </Button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    site: state.site,
  };
};

export default connect(mapStateToProps, { getSSODataCount })(CardSSOForm);
